import { render } from "./MyOrderPage.vue?vue&type=template&id=1dc0c024&scoped=true"
import script from "./MyOrderPage.vue?vue&type=script&lang=js"
export * from "./MyOrderPage.vue?vue&type=script&lang=js"

import "./MyOrderPage.vue?vue&type=style&index=0&id=1dc0c024&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc0c024"]])

export default __exports__